import type { LocationQuery } from "vue-router";

export enum SearchQueryParams {
  Page = "p",
  PageSize = "ps",
  FilterCategory = "fc",
  FilterService = "fs",
  FilterLanguage = "fl",
  FilterRegion = "fr",
  FilterExperienceMin = "fe_min",
  FilterExperienceMax = "fe_max",
  FilterPriceMin = "pf_min",
  FilterPriceMax = "pf_max",
  SortBy = "s",
}

export function parseQuery(q: LocationQuery, k: SearchQueryParams): string[] {
  const empty: string[] = [];
  if (!q[k]) {
    return empty;
  }
  const param = q[k];
  if (Array.isArray(param) && param.length) {
    return param.filter(Boolean).map(i => i!.toString()) || empty;
  }
  if (typeof param === "string") {
    return [param];
  }
  return empty;
}

export const SORT_BY_VALS = [
  "exp", // experience
  "hr_asc", // Cheap first (hourly_rate_asc)
  "hr_desc", // Pricy first (hourly_rate_desc)
  "rat", // rating
  "rev", // reviews_count
  "rec", // recommended
] as const;

export type SortBy = (typeof SORT_BY_VALS)[number];
